import { Directive } from '@angular/core';
import { BrnAccordionTrigger } from '@spartan-ng/brain/accordion';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: 'button[hlmAccordionTrigger]',
  hostDirectives: [BrnAccordionTrigger],
  host: { 'data-slot': 'accordion-trigger', type: 'button' },
})
export class HlmAccordionTrigger {
  constructor() {
    classes(
      () =>
        'focus-visible:border-ring focus-visible:ring-ring/50 flex w-full flex-1 items-center justify-between gap-4 rounded-md py-3 text-start text-sm font-medium outline-none transition-all hover:underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>ng-icon]:rotate-180 [&>ng-icon]:text-muted-foreground [&>ng-icon]:pointer-events-none [&>ng-icon]:shrink-0 [&>ng-icon]:translate-y-0.5 [&>ng-icon]:transition-transform [&>ng-icon]:duration-200',
    );
  }
}
